import React from 'react';
import { Skeleton } from 'antd';

const PLACEHOLDERS = [
  { rows: 2, width: ['55%', '72%'] },
  { rows: 3, width: ['80%', '65%', '40%'] },
  { rows: 2, width: ['60%', '50%'] },
];

const TeamAssistantChatMessagesSkeleton = () => (
  <div className="team-assistant-messages-skeleton" aria-busy="true" aria-label="Loading messages">
    {PLACEHOLDERS.map((item, index) => (
      <div
        key={index}
        className={`team-assistant-messages-skeleton-item ${
          index % 2 === 1 ? 'team-assistant-messages-skeleton-item--alt' : ''
        }`}
      >
        <Skeleton
          active
          avatar={{ size: 28 }}
          title={{ width: index % 2 === 0 ? '28%' : '22%' }}
          paragraph={{ rows: item.rows, width: item.width }}
        />
      </div>
    ))}
  </div>
);

export default TeamAssistantChatMessagesSkeleton;
